export default {
  title: 'Ajans',
  createAgency: 'Yeni bir Ajans oluşturun',
  joinAgency: 'Bir Ajansa Katılın',
  searchAgencyID: 'Ajans ID Ara',
  searchUserID: 'Kullanıcı kimliğini ara',
  star: 'Ajans yıldızı',
  viewMember: '{{count}} Üyeyi Görüntüle',
  reviewMessage: 'Ajans değerlendirmesi sırasında ilerlemeyi kontrol edin.',
  assessmentDate: 'Değerlendirme bitiş zamanı:',
  viewPersonal: 'Kişisel görüntüle',
  viewIncome: 'Geliri görüntüle',
  dissolution: 'Acente fesih bildirimi',
  agencyName: 'Acente Adı',
  agencySlogan: 'Ajans Sloganı',
  agencyBackground: 'ajans teması',
  wonderfulMoment: 'Harika bir an',
  dissolve: 'Ajans feshetmek',
  dissolveAgencyContent: 'Ajanstan maaşınızı almayacaksınız.',
  leaveAgency: 'Ajanstan ayrıl',
  disableAgency: 'Acenteliği feshetmek',
  leaveAgencyContent: 'Bu ajansı terk edeceksin.',
  owner: 'Oda sahipi',
  manager: 'Müdür',
  host: 'Ev sahibi',
  setManager: 'Yönetici olarak ayarla',
  unsetManager: 'Yöneticiyi kaldır',
  kickOut: 'Dışarı atmak',
  rewardGem: 'Ajan Maaşı',
  salary: {
    IncomeTips: 'Ajansım yayıncı Geliri',
    hostTips: 'yayıncılık geliriyle ev sahibi olun',
    rateTips: 'Ajansı Ödül Oranım',
  },
  supporters: 'Destekçiler: {{num}}',
  keepLevelSuccessfully: 'Seviyeyi başarıyla koruyun',
  keepLevel: 'Seviyeyi korumak',
  keepLevelRequire: 'Seviyeyi korumak için gereken: <span>{{num}}</span>',
  upgradeLevelRequires: 'Yükseltme seviyesi için gereken: <span>{{num}}</span>',
  kickOutContent: 'Sunucuyu atmaktan emin misiniz?',
  viewAgencySalary: 'Temsilci maaşını görüntüle',
  join: 'Katıl',
  newMembersJoin: 'Yeni üyeler katılıyor',
  assessing: 'Değerlendirme',
  shippingAgent: 'Nakliye Acentesi',
  create: {
    title: 'Ajans Oluştur',
    newDescription: 'Yeni acente değerlendirme dönemi açıklaması',
    toAgencies:
      'Deneyimi yetersiz ve kalitesiz acentelerin sisteme dahil edilmesini önlemek amacıyla yeni katılan acenteler için değerlendirme şartları belirledik.',
    assessmentRequirements: 'Değerlendirme gereksinimleri (Açılış töreni düzenleme)',
    assessmentRequirements2: 'Açılış Töreni Gereksinimleri',
    diamondsRequired: 'Gerekli Elmaslar',
    numberOfHosts: 'Ev Sahibi Sayısı',
    coinRewards: 'Altın Para Ödülleri',
    value: 'Değer ($)',
    withInDays: '{{num}} gün içinde',
    assessmentTime: 'Değerlendirme zamanı:',
    assessTips: 'Geçmek için aşağıdaki görevlerden herhangi birini tamamlayın',
    numHosts: '{{num}} Sunucular：',
    recruitAgency: 'Ajansa katılacak Ev Sahiplerini (temsilciler dahil) işe alın',
    receivedGems: 'Tüm ajansın aldığı mücevherler',
    agentRewards: 'Ajan Ödülleri',
    additionalNotes: 'Notlar',
    ifFail:
      '<span>{{num}} gün</span> içinde bir açılış töreni düzenlemez ve açılış töreni gereksinimlerini yerine getirmezseniz, ajansınız otomatik olarak kapatılacaktır. <br /> <br /> Altın para ödülleri acentenin hesabına gönderilecektir.',
    agentProfit: 'Ajan Karı',
    basicProfit: 'Temel Kar',
    agentCommission: "%20'ye varan acente komisyonu",
    activityProfit: 'Faaliyet Kârı (Sadece Acenteler)',
    activityProfit0: 'Yeni ajans açılış partisi bonusu en fazla $125',
    activityProfit1: 'Haftalık oda yarışmaları ödülleri en fazla $150',
    activityProfit2: 'Haftalık oda ödül etkinliği bonusları en fazla %18',
    activityProfit3: 'Aylık acente sıralaması bonusu en fazla %20',
    activityProfit4: 'Resmi düzensiz hediye desteği ve resmi etkinlik ödülleri',
    ifNeed:
      'Politikaların ayrıntılarına ihtiyacınız varsa lütfen resmi personelle iletişime geçin.',
    customerServiceRoom: 'Müşteri Hizmetleri Odası: 1001',
  },
  submit: {
    agencyName: 'Acente Adı',
    agencySlogan: 'Ajans Sloganı',
    introducer: 'Tanıtıcı',
    createAgency: 'Ajans Oluştur',
  },
  review: {
    recruitHosts: '<strong>{{count}} Sunucular:</strong> Ajansa katılacak Ev Sahiplerini işe alın',
    receivedGems: '<strong>{{count}} Mücevher:</strong> Tüm ajansın aldığı mücevherler',
  },
  quit: {
    title: 'Ajansı Terk Et?',
    joinTime: 'Katılma zamanı: ',
    quitFee: 'Ayrılma Ücreti:',
    quitDescription1: 'Bu ajansı terk etmek istediğinizden emin misiniz?',
    quitDescription2: '7 gün içinde ücretsiz ayrılabilirsiniz;',
    quitDescription3: '7 günden sonra ödeme yapmanız gerekir.',
    confirm: 'Onayla',
    cancel: 'İptal',
  },
};
